import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import type { FC } from 'react';
import { Switch } from 'src/common/components/switch';

import { Option } from '../option';
import { SettingProvider } from '../common';
import { useModel } from 'src/common/create-model';

export const LinkPage: FC = () => {
  const { t } = useAppTranslation();
  const {
    spaceSettingState: { showBackLink, setShowBackLink },
  } = useModel(SettingProvider);
  return (
    <Option
      title={t('components.space_setting.link_page.title')}
      description={t('components.space_setting.link_page.description')}
      rightPart={<Switch open={showBackLink} onSwitch={setShowBackLink} />}
    />
  );
};
